export default __webpack_public_path__ + "static/media/s-1.0d2a009c.jpg";